export default [
  {
    path: '/data/records',
    name: 'data-records',
    meta: {
      requiresAuth: true,
      title: 'Records - Innovation Law Lab Platform',
    },
    component: () => import('@/views/Data/Records'),
  },
]
